import { createRoute, useNavigate } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { signInWithGoogle } from '@/hooks/use-auth';
import { useAuthStore } from '@/stores/auth-store';
import { Button } from '@/components/ui/button';

export const signinRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/signin',
  component: SignInPage,
});

function SignInPage() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  if (user) {
    navigate({ to: '/redirect', search: { to: 'https://app.example.com' } });
    return null;
  }

  const handleGoogle = async () => {
    try {
      await signInWithGoogle();
    } catch (err) {
      console.error('Sign-in failed:', err);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="w-full max-w-sm p-6 text-center space-y-6">
        <h1 className="text-2xl font-bold">Sign In</h1>
        <p className="text-muted-foreground">Sign in to continue to the app</p>
        <Button onClick={handleGoogle} className="w-full" size="lg">
          Continue with Google
        </Button>
      </div>
    </div>
  );
}
